module.exports = __webpack_public_path__ + "media/images/redesign-images/higher-ed/event-01-dd5c4237363e6a704ec516036a048fae.jpg";